import React from 'react';
import FilterContainer from './FilterContainer';
import StatsContainer from './StatsContainer';

const SidebarTile = ({
  mediaType,
  statusOptions,
  search,
  onSearch,
  sortOption,
  onSortChange,
  sortDirection,
  onToggleSortDirection,
  filterLogic,
  onFilterLogicChange,
  filters,
  onFilterChange,
  visibleItems,
  allItems,
  isSidebarOpen,
  enableAnimations,
  onToggleAnimations,
  canViewExplicit,
}) => {
  return (
    <div className={`sidebar-tile ${isSidebarOpen ? 'active' : ''}`} id="sidebar-tile">
      <div className="sidebar-content">
        <div className="sort-search-container">
          <input
            type="text"
            id="search-bar-filter"
            className="input-field desktop-only"
            placeholder="Search..."
            value={search}
            onChange={onSearch}
          />
          <div className="sort-wrapper">
            <select id="sort-option" className="select-field" value={sortOption} onChange={onSortChange}>
              <option value="score">Score</option>
              <option value="title">Title</option>
              <option value="status">Status</option>
              {mediaType === 'SteamGame' && (
                <>
                  <option value="playtime">Playtime</option>
                  <option value="achievements_unlocked">Achievement Unlock Count</option>
                  <option value="achievements_locked">Achievement Locked Count</option>
                </>
              )}
              {(mediaType === 'Anime' || mediaType === 'AnimeMovie' || mediaType === 'AnimeSerie') && (
                <option value="current_episode">Current Episode</option>
              )}
            </select>
            <button
              id="sort-direction"
              type="button"
              className="btn btn-secondary"
              onClick={onToggleSortDirection}
              title={sortDirection === 'desc' ? 'Descending' : 'Ascending'}
            >
              <img
                src={sortDirection === 'desc' ? '/static/icons/sort-down-solid.svg' : '/static/icons/sort-up-solid.svg'}
                className="filter-icon icon"
                alt={sortDirection === 'desc' ? 'Descending' : 'Ascending'}
              />
            </button>
          </div>
        </div>

        <div className="filter-toggle">
          <label>Filter Logic:</label>
          <div className="toggle-switch">
            <input
              type="checkbox"
              id="filter-logic"
              checked={filterLogic === 'or'}
              onChange={onFilterLogicChange}
            />
            <span className="slider">
              <span className="label-and">AND</span>
              <span className="label-or">OR</span>
            </span>
          </div>
        </div>

        <FilterContainer
          statusOptions={statusOptions}
          filters={filters}
          onFilterChange={onFilterChange}
          visibleItems={visibleItems}
          allItems={allItems}
          canViewExplicit={canViewExplicit}
        />

        <div className="animation-toggle">
          <label>Animations:</label>
          <div className="toggle-switch">
            <input
              type="checkbox"
              id="animation-toggle"
              checked={enableAnimations}
              onChange={onToggleAnimations}
            />
            <span className="slider">
              <span className="label-off">OFF</span>
              <span className="label-on">ON</span>
            </span>
          </div>
        </div>

        <StatsContainer mediaType={mediaType} visibleItems={visibleItems} statusOptions={statusOptions} />
      </div>
    </div>
  );
};

export default SidebarTile;